import { Component, OnInit } from '@angular/core';
import { MyProfileService } from 'src/services/my-profile';
import { AuthenticationService } from 'src/app/_services';
import { ToasterService } from 'src/app/_services/toaster.service';
import { EventEmitterService } from 'src/global_services/event-emitter.service';
import { Title } from '@angular/platform-browser';
import { LoaderService } from 'src/app/_services/loader.service';
import { NiceScrollService } from 'src/app/_services/nice-scroll.service';
declare var $: any;
@Component({
    selector: 'app-profile-edit',
    templateUrl: './profile-edit.component.html',
    styleUrls: ['./profile-edit.component.css'],
    standalone: false
})
export class ProfileEditComponent implements OnInit {

  // public imagePath;
  PictureURL: any;
  ErrorMessage: string;
  public userFullName: string;
  public ProfileImageUrl: string;
  constructor(
    private eventEmitterService: EventEmitterService,
    private myProfileService: MyProfileService,
    private authenticationService: AuthenticationService,
    private toster: ToasterService,
    private title: Title,
    private loader: LoaderService,
    private niceScroll: NiceScrollService
    ) {
     // niceScroll.scrollToTop();
    }


  FirstName: string;
  LastName: string;
  UserName: string;
  EmailAddress: string;
  Phone: string;
  Address: string;
  About: string;
  Image: File;

  ngOnInit() {
    this.getUser();
    this.SetUserName();
    this.title.setTitle(this.userFullName + ' | Edit Profile | pakmatti.com');
  }

  public getUser() {
    this.loader.showLoader();
    this.myProfileService.getUserProfile().subscribe(userProfile => {
      this.FirstName = userProfile.FirstName;
      this.LastName = userProfile.LastName;
      this.UserName = userProfile.UserName;
      this.EmailAddress = userProfile.EmailAddress;
      this.Phone = userProfile.Phone;
      this.Address = userProfile.Address;
      this.About = userProfile.About;
      this.PictureURL = userProfile.ImageUrl;
      this.loader.hideLoader();
    });
  }

  public SetUserName() {
    const applicationUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userFullName = applicationUser.FirstName + ' ' + applicationUser.LastName;
    this.ProfileImageUrl = applicationUser.ImageUrl;
  }

  preview(files) {
    if (files.length === 0) {
      return;
    } else {
      this.Image = files[0];
      const mimeType = files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.toster.Warning('Only images are supported to upload');
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (event) => {
        this.PictureURL = reader.result;
      };
    }
  }


  HeaderComponentReInitiateFunction() {
    this.eventEmitterService.ComponentManipulator();
  }


  Logout(): void {
    //this.authenticationService.logout();
  }

  Submit() {
    this.loader.showLoader();
    const applicationUser = JSON.parse(localStorage.getItem('currentUser'));
    const formData = new FormData();
    formData.append('FirstName', this.FirstName);
    formData.append('LastName', this.LastName);
    formData.append('Phone', this.Phone);
    formData.append('Address', this.Address);
    formData.append('About', this.About);
    if (this.Image !== null || this.Image !== undefined) {
      formData.append('file', this.Image);
    }
    this.myProfileService.SaveProfile(formData).subscribe(userProfile => {
      if (userProfile.IsSuccess) {
        this.toster.Success(userProfile.Message);
        if (userProfile.Data.ImageUrl === '') {
          userProfile.Data.ImageUrl = applicationUser.ImageUrl;
        }
        userProfile.Data.EmailAddress = applicationUser.EmailAddress;
        localStorage.setItem('currentUser', JSON.stringify(userProfile.Data));
        this.SetUserName();
        this.HeaderComponentReInitiateFunction();
      } else {
        this.toster.Error(userProfile.Message);
      }
      this.loader.hideLoader();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
